import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[locale]/(client)/cities/[cityPage]/error.js");
